type TimeSalarySumRow = {
  id: string | null
  name: string | null
  salaryId: string | null
  sum: string | null
}

type OvertimeRow = {
  name: string | null
  sum: string | null
}

type LockedSalaryEntry = {
  salaryId: string | null
}

function toOvertimeKey(row: { name: string | null; sum: string | null }) {
  return `${row.name ?? ''}::${row.sum ?? ''}`
}

export function getVisibleTimedeltaSums(
  groupedActivitySums: TimeSalarySumRow[],
  overtimeRows: OvertimeRow[],
  lockedEntries: Array<LockedSalaryEntry | null>,
  isLocked: boolean
) {
  const sortedRows = [...groupedActivitySums].sort((a, b) =>
    (a.salaryId ?? '').localeCompare(b.salaryId ?? '')
  )

  if (!isLocked) return sortedRows

  const lockedSalaryIds = new Set(
    lockedEntries
      .map(entry => entry?.salaryId)
      .filter((salaryId): salaryId is string => Boolean(salaryId))
  )
  const overtimeKeys = new Set(overtimeRows.map(toOvertimeKey))

  return sortedRows.filter(activitySum => {
    if (!activitySum.salaryId) return true
    if (lockedSalaryIds.has(activitySum.salaryId)) return true

    return !overtimeKeys.has(toOvertimeKey(activitySum))
  })
}
